import { helper } from '@ember/component/helper';
import { ONE_HOUR_IN_SECONDS, ONE_DAY_IN_SECONDS } from 'cio/utils/time-constants';

export function secondsToReadable([duration, unit]) {
  if (!duration || !unit) {
    return;
  }
  let formatString = 'd [days], h [hours], m [minutes]';
  let durationInSeconds = duration.asSeconds();

  switch (unit) {
    case 'minute':
      formatString = durationInSeconds >= ONE_HOUR_IN_SECONDS ? 'h [hours and] m [minutes]' : 'm [minutes]';
      break;
    case 'hour':
      formatString = durationInSeconds >= ONE_DAY_IN_SECONDS ? 'd [days and] h [hours]' : 'h [hours]';
      break;
    case 'day':
      formatString = 'd [days]';
      break;
  }

  return duration.format(formatString);
}

export default helper(secondsToReadable);
